import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import {
  AsnCreateDto,
  OrderDetailReturnReasonPatchDto,
  PreInboundCreateDto
} from '../types'
import { DateTime } from 'luxon'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import {
  WorkOrderInBoundGrid,
  WorkOrderInBoundAdjust,
  WorkOrderInBoundAdjustGrid
} from '../../../interfaces/WorkOrder/WorkOrder'
import { AsnBlogCreate } from '../../../interfaces/Asn/AsnBlog'
import { AsnDetailPatch } from '../../../interfaces/Asn/Asn'
import { Filter } from '../../_WMS/FilterComponent'

export const createAsn = (dto: AsnCreateDto) => {
  const url = new URL(`${ApiConfig.AsnApi}`)
  return axios.post(url.toString(), dto)
}

export const getOrderDevolution = (searchBy: string, searchValue: string) => {
  const url = new URL(
    `${ApiConfig.AsnReturnApi}/OrderRelatedData?${searchBy}=${searchValue}`
  )
  return axios.get(url.toString())
}

export const getOrderDevolutionFromWorkOrder = (
  workOrderId: number,
  orderId?: number
) => {
  const url = new URL(
    `${
      ApiConfig.AsnReturnApi
    }/WorkOrder/${workOrderId.toString()}/OrderDetailRelatedData`
  )

  if (orderId) {
    url.searchParams.set('orderId', orderId.toString())
  }
  return axios.get(url.toString())
}

export const getAdjustReturnAsn = (
  supplierId: number | undefined,
  orderBy?: GenericOrderBy<WorkOrderInBoundGrid>,
  asnId?: number | null,
  workOrderId?: number | null,
  typeAsnIncomeId?: number | null,
  externalOrderId?: number | null,
  initialDate?: DateTime | null,
  finalDate?: DateTime | null,
  warehouseId?: number | null,
  pageIndex = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.InboundAdjust}`)

  url.searchParams.set('pageIndex', pageIndex.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  // type asn 2
  url.searchParams.set('typeAsnProcessId', '2')

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }
  if (asnId) {
    url.searchParams.set('asnId', asnId.toString())
  }
  if (supplierId) {
    url.searchParams.set('supplierId', supplierId.toString())
  }
  if (workOrderId) {
    url.searchParams.set('workOrderId', workOrderId.toString())
  }
  if (typeAsnIncomeId) {
    url.searchParams.set('typeAsnIncomeId', typeAsnIncomeId.toString())
  }
  if (externalOrderId) {
    url.searchParams.set('externalOrderId', externalOrderId.toString())
  }
  if (initialDate) {
    url.searchParams.set('InitialReceivedDate', initialDate.toString())
  }
  if (finalDate) {
    url.searchParams.set('FinalReceivedDate', finalDate.toString())
  }
  if (warehouseId) {
    url.searchParams.set('warehouseId', warehouseId.toString())
  }

  return axios.get(url.toString())
}

// obtiene datos para la cabecera con detalle de datos en formulario popup "ReturnAsnQualityControlDetail"
export const getAdjustReturnAsnQualityControl = (
  supplierId: number | undefined,
  orderBy?: GenericOrderBy<WorkOrderInBoundAdjust>,
  asnId?: number | null,
  workOrderId?: number | null,
  pageIndex = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.InboundAdjust}`)

  url.searchParams.set('pageIndex', pageIndex.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  // type asn 2
  url.searchParams.set('typeAsnProcessId', '2')

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  if (asnId) {
    url.searchParams.set('asnId', asnId.toString())
  }
  if (supplierId) {
    url.searchParams.set('supplierId', supplierId.toString())
  }
  if (workOrderId) {
    url.searchParams.set('workOrderId', workOrderId.toString())
  }

  return axios.get(url.toString())
}

// obtiene datos para llenar la grilla del formulario popup "ReturnAsnQualityControlGrid"
export const getAdjustAsnReturnSku = (
  orderBy?: GenericOrderBy<WorkOrderInBoundAdjustGrid>,
  workOrderId?: number | null,
  sku?: string | null,
  pageIndex = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.InboundAdjustSkuGetAsnReturnSku}`)

  url.searchParams.set('pageIndex', pageIndex.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }
  if (workOrderId) {
    // workOrderId = 48
    url.searchParams.set('workOrderId', workOrderId.toString())
  }

  if (sku) {
    url.searchParams.set('sku', sku.toString())
  }

  return axios.get(url.toString())
}

// obtiene datos para llenar la grilla del formulario popup "ReturnAsnQualityControlGrid"
export const getAsnState = (asnId: number) => {
  const url = new URL(`${ApiConfig.AsnApi}/${asnId}`)
  return axios.get(url.toString())
}

export const AsnReturnRelease = (
  asnId: number,
  userId: number,
  asnBlogCreate: AsnBlogCreate
) => {
  const url = new URL(
    `${ApiConfig.InboundAdjustReturnRelease}/?asnId=${asnId}&userId=${userId}`
  )

  return axios.patch(url.toString(), asnBlogCreate)
}

export const patchAsnDetail = (
  asnDetailId: number,
  asnDetailPatch: AsnDetailPatch
) => {
  const url = new URL(
    `${ApiConfig.AsnDetailApi}/AsnReturnQualityControlSku/${asnDetailId}`
  )

  return axios.patch(url.toString(), asnDetailPatch)
}

export const getPreInboundReason = () => {
  const url = new URL(`${ApiConfig.PreInboundReason}?pageIndex=0&pageSize=100`)
  return axios.get(url.toString())
}

// Grilla principal
export const getAsnReturn = (filters?: Filter[], page = 0, pageSize = 5) => {
  const url = new URL(`${ApiConfig.AsnReturnApi}`)
  url.searchParams.set('pageIndex', page.toString())

  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      if (element.key === 'externalStatusId') {
        url.searchParams.set('statusId', element.value)
      } else {
        url.searchParams.append(element.key, element.value.toString())
      }
    })
  }

  return axios.get(url.toString())
}

// Crear Pre-Asn
export const createPreInbound = (dto: PreInboundCreateDto) => {
  const url = new URL(`${ApiConfig.PreInbound}`)
  return axios.post(url.toString(), dto)
}

export const deletePreAsn = (preInboundId: number) => {
  const url = new URL(`${ApiConfig.PreInbound}/${preInboundId}`)
  return axios.delete(url.toString())
}

export const softDeleteAsn = (asnId: number) => {
  const url = new URL(`${ApiConfig.AsnApi}/SoftDelete?asnId=${asnId}`)
  return axios.delete(url.toString())
}

export const cancelAsn = (asnId: number) => {
  const url = new URL(`${ApiConfig.AsnApi}/CancelAsnAsync/${asnId}`)
  return axios.put(url.toString())
}

// Api busqueda información para formulario de selección de Lotes
export const AsnReturnOrderDetailReturnBatches = (
  preInboundId: number,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(
    `${ApiConfig.AsnReturnApi}/PreInbound/${preInboundId}/OrderDetailReturnBatches`
  )

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  return axios.get(url.toString())
}

// Grilla Step calidad
export const getQualityControlDetail = (
  sku: string | undefined,
  asnId: number,
  page = 0,
  pageSize = 5
) => {
  const url = new URL(`${ApiConfig.AsnReturnApi}/${asnId}/QualityControlDetail`)
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (sku && sku !== undefined) url.searchParams.set('sku', sku)

  return axios.get(url.toString())
}

// Actualiza datos de Control de Calidad por Detalle de Pedido Devuelto y su Motivo de Devolución
export const patchOrderDetailReturnReason = (
  asnId: number,
  orderDetailReturnReasonId: number,
  orderDetailReturnReasonPatchDto: OrderDetailReturnReasonPatchDto
) => {
  const url = new URL(
    `${ApiConfig.AsnReturnApi}/${asnId}/OrderDetailReturnReasons/${orderDetailReturnReasonId}`
  )

  return axios.patch(url.toString(), orderDetailReturnReasonPatchDto)
}

// obtiene los proveedores y origen de proveedor relacionados a la OT para poder Auto-selecionar los dropdownlist.
export const getSupplierAndSupplierOrigin = (warehouseId: number) => {
  const url = new URL(
    `${ApiConfig.SupplierApi}?warehouseId=${warehouseId}&pageIndex=0&pageSize=100`
  )

  return axios.get(url.toString())
}
